
































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import PublicAPI, { RegisterUser, SearchCompany } from '../common/PublicAPI'
import Site, { SiteDetail } from '../common/Site'
import t from '../i18n'
import countryListAllIsoData from '../common/CountryList'
import Utils from '../common/Utils'

const API = PublicAPI

@Component
export default class RegisterPage extends Vue {
  t = t
  Site = Site

  isRegistered = false
  isValidate = false
  firstname = ''
  lastname = ''
  email = ''
  marketingOptout = false
  isLoading = false
  business = 'business'
  country = ''
  dismissCountry = false
  countryValid = ''
  countryHighlightIndex = -1
  state = ''
  dismissState = false
  stateValid = ''
  stateHighlightIndex = -1
  password = ''
  company = ''
  abn = ''
  showPw = false
  countries: Array<string> = ['Australia', 'New Zealand', 'Indonesia', 'Singapore', 'Philippines', 'Malaysia', '----------']
  states: Record<string, Array<string>> = { Australia: ['New South Wales', 'Victoria', 'Queensland', 'Western Australia', 'South Australia', 'Tasmania', 'Northern Territory', 'Australian Capital Territory'] }
  hasEightChars = false
  hasOneLower = false
  hasOneUpper = false
  hasOneSpecial = false
  hasOneNumber = false
  tosFooter = ''
  abnError = ''
  loadingAbn = false
  loadingCompany = false
  abnValid = ''
  companyValid = ''
  companyOptions: Array<SearchCompany> = []

  private get isBusiness () { return this.business === 'business' }

  private async created () {
    document.body.classList.add('register-page')
    this.isRegistered = window.location.search.indexOf('done=1') >= 0
    this.isValidate = window.location.search.indexOf('validate=') >= 0
    this.isLoading = false
    document.title = Site.isPPBrand ? t('Position Partners SSO') : t('Aptella SSO')
    this.tosFooter = (Site.isPPBrand ? t('By clicking \'register\' above, you agree to Position Partners {0} and {1}') : t('By clicking \'register\' above, you agree to Aptella {0} and {1}'))
      .replace('{0}', (Site.isPPBrand ? '<a href="https://www.pos$itionpartners.com.au/services/terms-and-conditions/">' : '<a href="https://aptella.com/terms-and-conditions/">') + t('Terms & Conditions') + '</a>')
      .replace('{1}', (Site.isPPBrand ? '<a href="https://www.positionpartners.com.au/privacy-policy/">' : '<a href="https://aptella.com/privacy-policy/">') + t('Privacy Policy') + '</a>')

    const countrySet = new Set<string>(this.countries)
    for (const c of countryListAllIsoData) {
      if (!countrySet.has(c.name)) {
        this.countries.push(c.name)
      }
    }
  }

  private async register () {
    if (!Utils.validatePassword(this.password)) {
      alert(t('Password does not meet requirements'))
      return
    }
    if (this.country === 'Australia' && this.isBusiness && !RegisterPage.isValidABN(this.abn)) {
      alert(t('ABN Format invalid'))
      return
    }
    if (this.isBusiness && this.company === '') {
      alert(t('Company is required for Business accounts'))
      return
    }
    if (this.country === '') {
      alert(t('Country is required'))
      return
    }
    if (this.states[this.country] !== undefined && this.state === '') {
      alert(t('State is required'))
      return
    }
    const cookies = SiteDetail.getCookieMap()
    const ru: RegisterUser = {
      action: 'register',
      email: this.email,
      address: { country: this.country },
      given_name: this.firstname,
      family_name: this.lastname,
      password: this.password,
      personal_use: !this.isBusiness,
      marketing_optout: this.marketingOptout,
      csrf_token: cookies.get('csrf_token') || ''
    }
    if (this.state !== '') {
      ru.address.region = this.state
    }
    if (this.isBusiness) {
      ru.company = this.company
      if (this.country === 'Australia') {
        ru.abn = this.abn
      }
    }
    this.isLoading = true
    const resp = await API.postRegister(ru)
    if (resp !== null && !resp.error_detail) {
      this.isRegistered = true
    } else {
      alert('Failed to register.' + (resp && resp.error_detail ? ' ' + resp.error_detail : ''))
    }
    this.isLoading = false
  }

  private async resend () {
    this.isLoading = true
    const resp = await API.postRegister({ action: 'resend' })
    if (resp !== null && !resp.error_detail) {
      alert(t('Confirmation email resent'))
    } else {
      alert('Failed to resend email.' + (resp && resp.error_detail ? ' ' + resp.error_detail : ''))
    }
    this.isLoading = false
  }

  private login () {
    window.location.pathname = '/signin'
  }

  private getStates (c: string) {
    return this.states[c] || []
  }

  private get displayCountries () {
    if (this.countryValid === this.country) return this.countries
    return this.countries.filter((c) => c.toLowerCase().indexOf(this.country.toLowerCase()) >= 0)
  }

  @Watch('password')
  private onPasswordChange () {
    this.hasEightChars = this.password.length >= 8
    this.hasOneLower = Utils.lowerCase.split('').some((c) => this.password.indexOf(c) >= 0)
    this.hasOneUpper = Utils.upperCase.split('').some((c) => this.password.indexOf(c) >= 0)
    this.hasOneSpecial = Utils.special.split('').some((c) => this.password.indexOf(c) >= 0)
    this.hasOneNumber = Utils.numbers.split('').some((c) => this.password.indexOf(c) >= 0)
  }

  private companyUpdateVal = 1
  static nextCompanyUpdateVal = 1

  @Watch('company')
  private async onChangeCompany (evt: string) {
    if (evt !== this.companyValid) {
      if (evt.length === 0) {
        this.companyValid = ''
        return
      }
      if (evt.length > 3) {
        this.loadingCompany = true
        const myUpdateVal = RegisterPage.nextCompanyUpdateVal++
        this.companyUpdateVal = Math.max(this.companyUpdateVal, myUpdateVal)
        const resp = await API.getSearchCompany(evt)
        if (resp && myUpdateVal === this.companyUpdateVal) {
          if (resp.Message === '') {
            this.companyOptions = resp.Names.filter((c) => c.Abn !== undefined && c.IsCurrent)
          } else {
            this.companyOptions = [{ Name: resp.Message } as SearchCompany]
          }
          this.loadingCompany = false
        }
      }
    }
  }

  private get abnRequired () {
    return this.country === '' || this.country === 'Australia'
  }

  private selectCompany (c: SearchCompany) {
    this.companyValid = c.Name
    this.company = c.Name
    this.abnValid = c.Abn
    this.abn = c.Abn
    this.abnError = ''
    this.companyOptions = []
  }

  private get countryInput () { return this.$refs.countryInput as HTMLInputElement }
  private get stateInput () { return this.$refs.stateInput as HTMLInputElement }

  private selectCountry (c: string) {
    this.countryValid = c
    this.country = c
    this.countryHighlightIndex = this.countries.indexOf(c)
    this.countryInput.blur()
    this.dismissCountry = true
    this.$nextTick(() => { this.dismissCountry = false })
  }

  private selectState (c: string) {
    this.stateValid = c
    this.state = c
    this.stateHighlightIndex = this.getStates(this.country).indexOf(c)
    this.stateInput.blur()
    this.dismissState = true
    this.$nextTick(() => { this.dismissState = false })
  }

  @Watch('country')
  private onCountryChange () {
    if (this.country !== this.countryValid) {
      this.countryValid = ''
    }
    if (!this.country.length) {
      this.countryHighlightIndex = -1
    }
  }

  @Watch('state')
  private onStateChange () {
    if (this.state !== this.stateValid) {
      this.stateValid = ''
    }
    if (!this.state.length) {
      this.stateHighlightIndex = -1
    } else {
      this.stateHighlightIndex = this.getStates(this.country).findIndex((s) => s.toLowerCase().indexOf(this.state.toLowerCase()) >= 0)
    }
  }

  private onFocusCountry () {
    this.$nextTick(() => {
      this.scrollSelected()
    })
  }

  private onFocusState () {
    this.$nextTick(() => {
      this.scrollSelected()
    })
  }

  private onKeyDownCountry (evt: KeyboardEvent) {
    const code = evt.key || evt.which || evt.keyCode
    if (code === 13 || code === '13' || code === 'Enter' ||
        code === 9 || code === '9' || code === 'Tab' ||
        code === 27 || code === '27' || code === 'Escape') {
      this.dismissCountry = true
      this.$nextTick(() => { this.$nextTick(() => { this.dismissCountry = false }) })
      evt.preventDefault()
    } else if (code === 40 || code === '40' || code === 'ArrowDown') {
      this.countryHighlightIndex += 1
      evt.preventDefault()
    } else if (code === 38 || code === '38' || code === 'ArrowUp') {
      this.countryHighlightIndex -= 1
      evt.preventDefault()
    }
    const numDisplay = this.displayCountries.length - 1
    // Clamp to -1/max
    this.countryHighlightIndex = Math.min(numDisplay, Math.max(this.countryHighlightIndex, -1))
    const isFiltered = numDisplay !== this.countries.length
    if ((!isFiltered || this.dismissCountry) &&
        this.countryHighlightIndex >= 0 &&
        this.displayCountries[this.countryHighlightIndex] &&
        !this.displayCountries[this.countryHighlightIndex].startsWith('--')) {
      const c = this.displayCountries[this.countryHighlightIndex]
      this.countryValid = c
      this.country = c
      if (this.dismissCountry) {
        this.countryInput.blur()
        this.countryHighlightIndex = this.countries.indexOf(c)
      }
    }
    this.$nextTick(() => this.scrollSelected())
  }

  private onKeyDownState (evt: KeyboardEvent) {
    const code = evt.key || evt.which || evt.keyCode
    if (code === 13 || code === '13' || code === 'Enter' ||
        code === 9 || code === '9' || code === 'Tab' ||
        code === 27 || code === '27' || code === 'Escape') {
      this.dismissState = true
      this.$nextTick(() => { this.$nextTick(() => { this.dismissState = false }) })
      evt.preventDefault()
    } else if (code === 40 || code === '40' || code === 'ArrowDown') {
      this.stateHighlightIndex += 1
      evt.preventDefault()
    } else if (code === 38 || code === '38' || code === 'ArrowUp') {
      this.stateHighlightIndex -= 1
      evt.preventDefault()
    }
    const states = this.getStates(this.country)
    const numDisplay = states.length - 1
    // Clamp to -1/max
    this.stateHighlightIndex = Math.min(numDisplay, Math.max(this.stateHighlightIndex, -1))
    if (this.stateHighlightIndex >= 0 &&
        states[this.stateHighlightIndex] &&
        !states[this.stateHighlightIndex].startsWith('--')) {
      const c = states[this.stateHighlightIndex]
      if (this.dismissState || this.state === this.stateValid) {
        this.stateValid = c
        this.state = c
        if (this.dismissState) {
          this.stateInput.blur()
          this.stateHighlightIndex = this.countries.indexOf(c)
        }
      }
    }
    this.$nextTick(() => this.scrollSelected())
  }

  private abnUpdateVal = 1
  static nextAbnUpdateVal = 1
  @Watch('abn')
  private async onChangeABN (evt: string) {
    const newAbn = RegisterPage.formatABN(evt)
    if (newAbn !== this.abn) {
      this.abn = newAbn
    }

    if (!RegisterPage.isValidABN(this.abn)) return

    if (evt !== this.abnValid) {
      if (evt.length === 0) {
        this.abnError = ''
        this.abnValid = ''
        return
      }
      this.loadingAbn = true
      const myUpdateVal = RegisterPage.nextAbnUpdateVal++
      this.abnUpdateVal = Math.max(this.abnUpdateVal, myUpdateVal)
      const resp = await API.getSearchABN(evt)
      if (resp && myUpdateVal === this.abnUpdateVal) {
        this.abnError = resp.Message
        if (this.abnError === '' && resp.EntityName) {
          this.abnValid = resp.Abn
          this.companyValid = resp.EntityName
          this.company = resp.EntityName
        } else {
          this.abnValid = ''
        }
        this.loadingAbn = false
      }
    }
  }

  static isValidABN (abn: string | null | undefined): boolean {
    if (!abn) return false
    // ABN format: "XX XXX XXX XXX" where X is a digit from 0-9
    return abn.match(/^\d\d \d\d\d \d\d\d \d\d\d$/) !== null
  }

  static formatABN (abn: string | null | undefined): string {
    if (RegisterPage.isValidABN(abn)) return abn as string
    if (!abn) return ''
    const val = abn.replace(/[\D]+/g, '')
    const newAbn = (val.slice(0, 2) + ' ' + val.slice(2, 5) + ' ' + val.slice(5, 8) + ' ' + val.slice(8, 11)).trim()
    return newAbn
  }

  private scrollSelected () {
    document.querySelectorAll('.search-results .selected').forEach((el) => { el.scrollIntoView(false) })
  }
}
